/**
 * ohbookmark Delivery Estimate
 * 检测用户 IP 地理位置 → 查配送时效表 → 计算预计到货日期 → 渲染到页面
 * .oh-delivery-estimate      → 价格行：使用 settings 中的 prefix/suffix（Arrives soon! Get it by … if you order today）
 * .oh-delivery-estimate--compact → 手风琴：固定 "Order today to get by [date]" 格式，继承父级样式
 */
(function () {
  'use strict';

  /* ---- 常量 ---- */
  var API_PRIMARY = 'https://ipapi.co/json/';
  var API_FALLBACK = 'https://api.country.is/';
  var TIMEOUT_MS = 3000;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ---- 入口 ---- */
  function init() {
    // 从 price 区容器读取配置（两个容器共享）
    var mainEl = document.querySelector('.oh-delivery-estimate');
    var config = mainEl ? readConfig(mainEl) : null;

    // 渲染 price 区
    var containers = document.querySelectorAll('.oh-delivery-estimate');
    for (var i = 0; i < containers.length; i++) {
      (function (el) {
        detectCountry(function (countryCode) {
          renderEstimate(el, countryCode, config);
        });
      })(containers[i]);
    }

    // 渲染手风琴区 — 固定前缀、无后缀、继承父级样式
    var compacts = document.querySelectorAll('.oh-delivery-estimate--compact');
    for (var j = 0; j < compacts.length; j++) {
      (function (el) {
        detectCountry(function (countryCode) {
          renderCompact(el, countryCode, config);
        });
      })(compacts[j]);
    }
  }

  /* ---- 从 data-* 读取配置 ---- */
  function readConfig(el) {
    return {
      transitTable: el.getAttribute('data-transit-table') || '{}',
      processingDays: parseInt(el.getAttribute('data-processing-days'), 10) || 1,
      prefix: el.getAttribute('data-prefix') || 'Arrives soon! Get it by',
      suffix: el.getAttribute('data-suffix') || 'if you order today',
      fallback: el.getAttribute('data-fallback') || ''
    };
  }

  /* ---- IP 地理位置（双层备选） ---- */
  function detectCountry(callback) {
    var cached = null;
    try { cached = sessionStorage.getItem('oh_delivery_country'); } catch (e) {}
    if (cached) {
      callback(cached);
      return;
    }

    fetchWithTimeout(API_PRIMARY, TIMEOUT_MS, function (err, data) {
      if (!err && data && data.country_code) {
        try { sessionStorage.setItem('oh_delivery_country', data.country_code); } catch (e) {}
        callback(data.country_code);
        return;
      }
      fetchWithTimeout(API_FALLBACK, TIMEOUT_MS, function (err2, data2) {
        if (!err2 && data2 && data2.country) {
          try { sessionStorage.setItem('oh_delivery_country', data2.country); } catch (e) {}
          callback(data2.country);
          return;
        }
        callback(null);
      });
    });
  }

  /* ---- XHR 请求（带超时） ---- */
  function fetchWithTimeout(url, ms, callback) {
    var xhr = new XMLHttpRequest();
    var done = false;
    xhr.open('GET', url, true);
    xhr.timeout = ms;
    xhr.onload = function () {
      if (done) return;
      done = true;
      try {
        var data = JSON.parse(xhr.responseText);
        callback(null, data);
      } catch (e) {
        callback(e, null);
      }
    };
    xhr.onerror = function () {
      if (done) return;
      done = true;
      callback(new Error('Network error'), null);
    };
    xhr.ontimeout = function () {
      if (done) return;
      done = true;
      callback(new Error('Timeout'), null);
    };
    xhr.send();
  }

  /* ---- 解析时效表 ---- */
  function getTransitDays(transitTable, countryCode) {
    var table = {};
    try { table = JSON.parse(transitTable); } catch (e) {}

    if (countryCode && table[countryCode]) return table[countryCode];
    if (table['default']) return table['default'];
    return [15, 25];
  }

  /* ---- 工作日递推（跳过周六日） ---- */
  function addBusinessDays(startDate, businessDays) {
    var d = new Date(startDate.getTime());
    var added = 0;
    while (added < businessDays) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  /* ---- 日期格式化 ---- */
  function formatDateRange(earliest, latest) {
    var eMonth = MONTHS[earliest.getMonth()];
    var eDay = earliest.getDate();
    var lMonth = MONTHS[latest.getMonth()];
    var lDay = latest.getDate();

    if (eMonth === lMonth) {
      return eMonth + ' ' + eDay + '–' + lDay;
    }
    return eMonth + ' ' + eDay + '–' + lMonth + ' ' + lDay;
  }

  /* ---- 渲染 price 区 ---- */
  function renderEstimate(el, countryCode, config) {
    var prefix = config ? config.prefix : 'Arrives soon! Get it by';
    var suffix = config ? config.suffix : 'if you order today';
    var transitTable = config ? config.transitTable : '{}';
    var processingDays = config ? config.processingDays : 1;
    var fallback = config ? config.fallback : '';

    if (!countryCode) {
      el.innerHTML = '<span class="oh-delivery-estimate__text">'
        + escapeHTML(fallback) + '</span>';
      return;
    }

    var transit = getTransitDays(transitTable, countryCode);
    var today = new Date();
    var shipDate = addBusinessDays(today, processingDays);
    var earliest = addBusinessDays(shipDate, transit[0]);
    var latest = addBusinessDays(shipDate, transit[1]);
    var dateStr = formatDateRange(earliest, latest);

    var suffixPart = suffix ? ' ' + escapeHTML(suffix) : '';
    el.innerHTML = '<span class="oh-delivery-estimate__text">'
      + escapeHTML(prefix) + ' '
      + '<strong class="oh-delivery-estimate__dates">' + escapeHTML(dateStr) + '</strong>'
      + suffixPart + '</span>';
  }

  /* ---- 渲染手风琴区（compact） ---- */
  function renderCompact(el, countryCode, config) {
    var transitTable = config ? config.transitTable : '{}';
    var processingDays = config ? config.processingDays : 1;

    if (!countryCode || !config) {
      el.textContent = 'Order today to get by …';
      return;
    }

    var transit = getTransitDays(transitTable, countryCode);
    var today = new Date();
    var shipDate = addBusinessDays(today, processingDays);
    var earliest = addBusinessDays(shipDate, transit[0]);
    var latest = addBusinessDays(shipDate, transit[1]);
    var dateStr = formatDateRange(earliest, latest);

    el.innerHTML = 'Order today to get by '
      + '<strong>' + escapeHTML(dateStr) + '</strong>';
  }

  /* ---- HTML 转义 ---- */
  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ---- 启动 ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
